import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=7844328f&scoped=true&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"
import style0 from "./Hub.vue?vue&type=style&index=0&id=7844328f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7844328f",
  null
  
)

export default component.exports